import { GridColumn } from 'src/components/GridWrapper';
import FileIconCell from 'src/components/custom-cells/FileIconCell';
import UploadDate from 'src/components/scanner/UploadDate';
import { FileIcon } from '../scan_manager/scanManagerColumns';

export const attachScansColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    width: '30px',
    menu: false,
  },
  {
    field: 'file',
    title: 'file',
    component: FileIconCell,
    headerCell: FileIcon,
    width: '40px',
    menu: false,
  },
  {
    field: 'originalFile',
    title: 'File Name',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'createdBy',
    title: 'Uploaded By',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'creationDate',
    title: 'Uploaded On',
    filter: 'date',
    dataType: 'date',
    format: '',
    component: UploadDate,
    editable: false,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    dataType: 'string',
  },
];
